// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__134rP","content":"styles_content__Y9PJI"};